import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../stores/authenticationStore'

export const PositionRequest = {
  getPositionList: () =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/positions`,
      headers: {
        'Authorization': `Bearer ${JSON.parse(authenticationStore.appToken).access_token}`,
        'Content-Type': 'application/json',
      },
    }),
}
